export class ClaudeEnterpriseOrganizationIdFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseOrganizationIdFilters.attributeTypeMap;
    }
    constructor() {
    }
}
